<template>
    <v-card
    flat
    
    
    >
     <v-card-text>
         <v-layout>
          <v-flex xs9 class="pr-2">
            <v-textarea
              v-model="q.title"
              label="Vraag"
              @change="q.modified=true"
              class="minimal transparent"
              auto-grow
              :rows=1
                      hide-details
            ></v-textarea>
        </v-flex>
        <v-flex xs3 v-if="!Role('lead')">
          <v-select
                             v-model="q.type"
                              :items="types"
                              label="Type"
                              item-text="label"
                              item-value="value"
                              @change="change"
                            ></v-select>
        </v-flex>
        </v-layout>
         <v-layout>
          <v-flex xs10 class="pr-2">
         <v-textarea
                      v-model="q.description"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      label="Toelichting....."
                      class="minimal transparent"
                      @change="save"
                      :rows=1
                      
                    ></v-textarea>
             </v-flex>   
              <v-flex xs1>
                      <v-text-field
            label="Duur"
            v-model="q.duration"
            suffix="min"
            @change="save"
            
          ></v-text-field>
                   </v-flex>
              <v-flex xs1>
                      <v-switch
                       v-if="!Role('lead')"
          v-model="q.optional"
          label="Optioneel"
          class="mt-5"
          @change="save"
        ></v-switch>
                   </v-flex>
        </v-layout>    
                        <v-combobox 
                            v-if="q.type!='text' && !Role('lead')"
                            v-model="q.options"
                            label="Opties"
                            chips
                            flat
                            dense
                            hide-details
                            small-chips
                            multiple
                            @change="save"
                            class="my-5"
                            append-icon
                          >
                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                  <v-chip
                                    v-bind="attrs"
                                    :input-value="selected"
                                    label
                                    small
                                    outlined
                                  >
                                    <span class="pr-2">
                                      {{ item }}
                                    </span>
                                    <v-icon
                                      small
                                      @click="parent.selectItem(item);save()"
                                    >close</v-icon>
                                  </v-chip>
                                </template>
                          </v-combobox>
                           <v-textarea
                          v-if="ifAntwoord && !Role('lead')"
                      v-model="q.answer"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      label="Antwoordtekst....."
                      class="transparent"
                      @change="save"
                      :rows=1
                      
                    ></v-textarea>
                          <v-textarea
                          v-if="ifJa"
                      v-model="q.answer"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      label="Antwoord bij JA....."
                      class="transparent"
                      @change="save"
                      :rows=1
                      
                    ></v-textarea>
                    <v-textarea
                        v-if="ifNee"
                      v-model="q.no_answer"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      label="Antwoord bij NEE....."
                      class="transparent"
                      @change="save"
                      :rows=1
                      
                    ></v-textarea>
                          </v-card-text>
                           <v-card-actions v-if="form">
                          <v-spacer></v-spacer>
                          <v-btn color="error" text @click="del">Verwijderen</v-btn>
                           <v-btn color="success" text @click="save">Klaar</v-btn>
                          </v-card-actions>
     
     
  </v-card>
    
</template>
<script>
import {
  mapGetters, mapMutations
} from 'vuex'
export default {
  props: {
      add : {
          type: Boolean,
          default: false
      },
      question: {
        type: Object,
        default: () => {}
      },
      answer: {
        type: Object,
        default: () => {}
      },
      hover : {
          type: Boolean,
          default: false
      },
      form: {
          type: Boolean,
          default: false
      }
    },
   data: () => ({
      q: {},
      types: [
           {label:"Tekst", value: "text"},
           {label: "Keuzelijst", value:"radio"},
           {label: "Meerkeuzelijst", value: "check"}
          ]
  }),
  computed: {
      ...mapGetters('match', ['currentQuestion']),
      ...mapGetters('auth', ["Role",'relation','maincontact','role']),
    ifAntwoord(){
      return !this.ifJa && !this.ifNee
    },
    ifJa() {
      if (this.question.type!='text' && this.question.options && this.question.options.indexOf('JA') > -1) return true
      return false
    },
    ifNee() {
      if (this.question.type!='text' && this.question.options && this.question.options.indexOf('NEE') > -1) return true  
      return false
    },
    answered() {
        return this.answer.question ? true: false
    },
    current(){
        if (!this.currentQuestion) return false
        return this.currentQuestion.title ==   this.question.title
    },
    text () {
      return this.question.text
    },
    type () {
      return this.question.type
    },
    options () {
        if (this.question.type == 'check' && this.answer.options && this.answer.options.length>0) return this.answer.options.join(', ')
        return false
    }
  },
  watch: {
    question(value, old) {
        this.load()
    }  

  },
  mounted() {
    this.load()
  },
  methods: {
      ...mapMutations('match', ["setQuestion","deleteQuestion"]),
    load(){
        this.q = Object.assign({}, this.question);
        if (!this.form) this.q = this.question
    },
    answerThis () {
        this.$emit('answer', this.question)
    },
    del(){
         this.$emit('delete', this.answer)
    },
    addToAnswer() {
        /*var t = this.question.text
        if (t == '') return false
        this.question.text = ''*/
        this.$emit('update', this.answer.text, this.answer )
    },
    change(){
        if (this.question.type == 'radio' && (!this.question.options|| this.question.options.length == 0)) this.question.options = ["JA","NEE"]
    },
    save(){
      this.modified = true;
      this.$emit('save')
    },
     questionMark(question) {
              if (question.title && question.title.indexOf('?') == -1) return '?'
          }
  }
}

</script>
